import React from "react";
import "./pricing.css";
import NavbarSection from "../../NavBar/Navbar.js";
import FooterSection from "../../NewFooter/Footer.js";

function Pricing() {
  document.title = "3VO | Pricing";

  return (
    <div className="bg-pages">
      <NavbarSection />
      <div className="embed rapper-style">
        <div className="embed-container">
          <div className="embed-title">3VO Pricing Policy</div>
          <h1 className="embed-privacy-inner-titles">
            3VOgram Diamonds: Pricing & Purchase Options
          </h1>
          <div className="embed-privacy">
            <br />

            <h3>In-App USD Packs</h3>
            <table
              style={{
                width: "100%",
                borderCollapse: "collapse",
                margin: "20px 0",
              }}
            >
              <thead>
                <tr style={{ backgroundColor: "rgba(0, 0, 0, 1)ff" }}>
                  <th
                    style={{
                      border: "1px solid #ddd",
                      padding: "12px",
                      textAlign: "left",
                    }}
                  >
                    Pack Name
                  </th>
                  <th
                    style={{
                      border: "1px solid #ddd",
                      padding: "12px",
                      textAlign: "left",
                    }}
                  >
                    Diamonds
                  </th>
                  <th
                    style={{
                      border: "1px solid #ddd",
                      padding: "12px",
                      textAlign: "left",
                    }}
                  >
                    Stars Price
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style={{ border: "1px solid #ddd", padding: "12px" }}>
                    Starter Pack
                  </td>
                  <td style={{ border: "1px solid #ddd", padding: "12px" }}>
                    10 + 1 Extra
                  </td>
                  <td style={{ border: "1px solid #ddd", padding: "12px" }}>
                    $ 0.99
                  </td>
                </tr>
                <tr>
                  <td style={{ border: "1px solid #ddd", padding: "12px" }}>
                    Pro Pack
                  </td>
                  <td style={{ border: "1px solid #ddd", padding: "12px" }}>
                    55 + 5 Extra
                  </td>
                  <td style={{ border: "1px solid #ddd", padding: "12px" }}>
                    $ 4.99
                  </td>
                </tr>
                <tr>
                  <td style={{ border: "1px solid #ddd", padding: "12px" }}>
                    Master Pack
                  </td>
                  <td style={{ border: "1px solid #ddd", padding: "12px" }}>
                    220 + 25 Extra
                  </td>
                  <td style={{ border: "1px solid #ddd", padding: "12px" }}>
                    $19.99
                  </td>
                </tr>
                <tr>
                  <td style={{ border: "1px solid #ddd", padding: "12px" }}>
                    Champion Pack
                  </td>
                  <td style={{ border: "1px solid #ddd", padding: "12px" }}>
                    550 + 90 Extra
                  </td>
                  <td style={{ border: "1px solid #ddd", padding: "12px" }}>
                    $49.99
                  </td>
                </tr>
                <tr>
                  <td style={{ border: "1px solid #ddd", padding: "12px" }}>
                    Legendary Pack
                  </td>
                  <td style={{ border: "1px solid #ddd", padding: "12px" }}>
                    1100 + 200 Extra
                  </td>
                  <td style={{ border: "1px solid #ddd", padding: "12px" }}>
                    $99.99
                  </td>
                </tr>
              </tbody>
            </table>
            <p style={{ fontStyle: "italic", fontSize: "14px" }}></p>
            <br />
            <br />
            <p>
              {" "}
              <strong>How to Buy</strong>
              <br />
              <br />
              <strong>• USD Packs:</strong> Buy directly in-app with your
              preferred payment method.
            </p>
          </div>
        </div>
      </div>
      <FooterSection />
    </div>
  );
}

export default Pricing;
